module.exports = __webpack_public_path__ + "static/9-21e992524992ccab81efadd4a8c3a2f0.png";